'use strict';

module.exports = {
  LANDING_FRAME_NAME: 'braintreethreedsecurelanding'
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/three-d-secure/shared/constants.js
// module id = 836
// module chunks = 0